<div class="flex flex-col gap-6 w-full">
  <!-- 상단 네비게이션 -->
  <div class="flex flex-col gap-4 lg:flex-row lg:justify-between items-center">
    <!-- 연도 네비게이션 -->
    <div class="flex items-center gap-3 w-full justify-center lg:justify-start">
      <button
        class="cursor-pointer size-5 lg:size-6 rounded-full bg-zinc-300 items-center justify-center flex"
        (click)="prevYear()">
        <app-icon name="material-symbols:arrow-back-ios-new" class="size-3! text-white" />
      </button>
      <h1 class="text-xl lg:text-2xl text-zinc-800">{{ currentYear() }}년</h1>
      <button
        class="cursor-pointer size-5 lg:size-6 rounded-full bg-zinc-300 items-center justify-center flex"
        (click)="nextYear()">
        <app-icon name="material-symbols:arrow-forward-ios" class="size-3! text-white" />
      </button>
    </div>

    <!-- 검색 -->
    <div class="search-box">
      <app-icon name="ic:round-search" class="size-5! text-zinc-400"></app-icon>
      <input type="text" placeholder="검색어를 입력하세요" (input)="onSearchInput($event)" />
    </div>
  </div>

  <!-- 이벤트 목록 -->
  <div class="list-content">
    @if (filteredEvents().length === 0) {
    <app-not-found [(query)]="searchQuery">
      <p class="text-zinc-500">해당 연도에 등록된 행사가 없습니다.</p>
    </app-not-found>
    } @else {
    <div class="event-list">
      @for (event of filteredEvents(); track event.id) {
      <div class="group event-card cursor-pointer" [routerLink]="['/event', event.id]">
        <div class="flex flex-col gap-4">
          <div class="event-card-header flex flex-col gap-2">
            <div class="flex justify-between items-center">
              <span
                [class]="
                  'inline-flex items-center px-2.5 py-0.5 rounded-full w-fit text-xs font-medium ' +
                  getStatusBadge(event.status).class
                ">
                {{ getStatusBadge(event.status).text }}
              </span>
              <app-icon
                name="material-symbols:arrow-outward-rounded"
                class="size-5! text-zinc-400 group-hover:text-orange-500 transition-colors" />
            </div>
            <h1 class="text-xl font-light">{{ event.title }}</h1>
          </div>
          <div class="h-px bg-zinc-200"></div>
          <div class="event-card-body">
            @if (event.place) {
            <div class="event-info">
              <app-icon name="material-symbols:location-on-rounded" class="size-4! text-zinc-300" />
              <span>{{ event.place.name }}</span>
            </div>
            }
            <div class="event-info">
              <app-icon name="solar:calendar-bold-duotone" class="size-4! text-zinc-300" />
              <span>{{ formatDateRangeShort(event.startAt, event.endAt) }}</span>
            </div>
            <div class="event-info">
              <app-icon name="solar:alarm-bold-duotone" class="size-4! text-zinc-300" />
              <span>{{ formatTime(toDate(event.startAt)) }} - {{ formatTime(toDate(event.endAt)) }}</span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
